import { render } from "./AssignPositionView.vue?vue&type=template&id=3b82df3b&scoped=true"
import script from "./AssignPositionView.vue?vue&type=script&lang=js"
export * from "./AssignPositionView.vue?vue&type=script&lang=js"

import "./AssignPositionView.vue?vue&type=style&index=0&id=3b82df3b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b82df3b"]])

export default __exports__